import { render, staticRenderFns } from "./editHistoricalData.vue?vue&type=template&id=582376de&scoped=true&"
import script from "./editHistoricalData.vue?vue&type=script&lang=js&"
export * from "./editHistoricalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582376de",
  null
  
)

export default component.exports